import {
  Box,
  Flex,
  Spacer,
  HStack
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { Page } from "src/components/storyblok/Page";

import theme from "../../components/theme";
import { Button } from "../../components/button";
import { Text } from "../../components/text";
import { ReactComponent as ArrowRightSvg } from "../../assets/icons/arrow-right.svg";
import { routes } from "../../constants";

export const ReduceRootPage: React.FC = () => (
  <>
    <Page />

    {/* some extra breathing room before footer */}

    <Spacer
      py="2rem"
      order={3}
    />

  </>
);

/*
    <Box order={{ xl: 1 }}>

      <ColumnLayout
        key={copy.title}
        title={copy.title}
        content={copy.content}
        py={columnSpacing}
      />

    </Box>

    <FullSpace background={{ xl: `linear-gradient(to bottom, ${theme.colors.gray[ 100 ]} 250px, transparent 250px)` }}>
      <Box
        order={0}
        as={Flex}
        flexDirection="row"
        flexWrap="wrap"
        justifyContent="center"
        alignItems="center"
        spacing="0"
        gap={theme.spacing[ 8 ]}
        py="1rem"
        maxW="min(2000px, 90%)"
        minWidth="90%"
        justifyItems="center"
        mx="auto"
        padding="1rem"
      >
        {Object.entries(topicPreviewContent).map(([
          title,
          {
            imgAlt, imgSrc, text
          }
        ], index) => (
          <ReduceCarbonTopicPreview
            key={index.toString()}
            title={title}
            text={text}
            imgSrc={imgSrc}
            imgAlt={imgAlt}
            mx="1rem !important"
            _last={{ mr: "auto" }}
            small={{
              base: true,
              lg: false
            }}
            mb="1rem"
          />
        ))}
      </Box>

    </FullSpace>

*/

const copy =
  {
    title: "We can help with every step",
    content: [
      "Our carbon concierge service establishes the best ways for you to reduce your carbon output. Then we can arrange the right services and teams to seamlessly put those changes in place.",
      (
        <Button
          as={Link}
          to={routes.welcome}
          uppercase={false}
          key="start-now-button"
          marginTop={theme.spacing[ 5 ]}
        >
          <HStack>
            <Text
              as={Link}
              to={routes.welcome}
              color="white !important"
            >
              Start now
            </Text>

            <Box
              as="span"
              w="1em"
              color={theme.colors.green[ 200 ]}
            >
              <ArrowRightSvg
                width="100%"
                height="100%"
                fill="currentColor"
              />
            </Box>
          </HStack>
        </Button>
      )
    ]
  };
